import * as React from "react";
import { ReactNode } from "react";
import { styled } from "styled-components";

import { Grid } from "affinityUI/elements/grid";
import { typeScale } from "lib/themeUtils";

const Content = styled.div`
  margin-top: 0.3rem;
`;

const Section = styled.section`
  border: none;
  width: 100%;

  form & {
    border-bottom: 1px solid ${({ theme }) => theme.colours.bordersLight};
    margin: 0 0 2rem 0;
    padding: 0 0 2rem 0;
  }
`;

const Title = styled.h2`
  ${typeScale.xl};
  font-weight: bold;
  margin: 0 0 1rem 0;
`;

export const DataEntryGroup: React.FC<
  React.PropsWithChildren<{ title: string; description?: ReactNode; id: string; className?: string }>
> = ({ title, description, children, id, className }) => {
  const sectionId = `content-section-${id}`;
  return (
    <Section id={id} role="group" aria-labelledby={sectionId} className={className}>
      <Grid $cols={[1, 3]}>
        <div>
          <Title id={sectionId}>{title}</Title>
          {description}
        </div>
        <Content>{children}</Content>
      </Grid>
    </Section>
  );
};
